import React from 'react';
import { colors } from '../utils/colors';
interface StakeholderCardProps {
  type: string;
  count: number;
  percentage: number;
  color: string;
}
const StakeholderCard: React.FC<StakeholderCardProps> = ({
  type,
  count,
  percentage,
  color
}) => {
  // Map the old color values to new ones
  const getNewColor = () => {
    switch (color) {
      case 'bg-blue-500':
        return colors.primary.dark;
      case 'bg-blue-400':
        return colors.primary.medium;
      case 'bg-blue-300':
        return colors.primary.light;
      case 'bg-blue-200':
        return colors.ui.lightTeal;
      case 'bg-blue-100':
        return colors.ui.veryLightTeal;
      default:
        return colors.primary.medium;
    }
  };
  const newColor = getNewColor();
  return <div className="bg-white rounded-lg shadow p-4" data-id="element-96">
      <div className="flex items-center" data-id="element-97">
        <div className="w-3 h-3 rounded-full" style={{
        backgroundColor: newColor
      }} data-id="element-98"></div>
        <h3 className="ml-2 text-sm font-medium text-gray-900" data-id="element-99">{type}</h3>
      </div>
      <div className="mt-2" data-id="element-100">
        <p className="text-2xl font-semibold" style={{
        color: colors.primary.dark
      }} data-id="element-101">
          {count}
        </p>
        <p className="text-sm text-gray-500" data-id="element-102">{percentage}% of submissions</p>
      </div>
      <div className="mt-4" data-id="element-103">
        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-104">
          <div className="h-2 rounded-full" style={{
          width: `${percentage}%`,
          backgroundColor: newColor
        }} data-id="element-105"></div>
        </div>
      </div>
    </div>;
};
export default StakeholderCard;